import { HttpService } from "./../../../wrappers/Http";
import { Injectable, ɵConsole } from "@angular/core";
import { StorageService } from "../../storage.service";
import { BehaviorSubject } from "rxjs";
import { ModalService } from "../../modal-service/ModalService";
import { ConfigService } from "../../config/config.service";
import { Router, ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from '../../auth.service';
import { Partner } from "src/app/interfaces/partners";
import { CustomerAuthResp, User } from "src/app/interfaces/customer-data.model";
import { EndPoints } from "src/app/configs";
import { customerTransPayload } from "src/app/interfaces/transactions";
import * as moment from 'moment';
import { isNullOrEmpty } from "src/app/functions/trim-json-value.function";
import { STORAGE_KEYS } from "src/app/enums/storage-keys.enum";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class UserManagerService {
  verifyUser = false;
  setRefreshOfToken = false;
  userID = "";
  userphone = "";
  urlSessionId = "";
  lastActiveTime: any;
  userManagementService: any;
  idleInterval: any;
  userIdleTime: any;
  checkIdletime: boolean = false;
  partners: Array<Partner> = new Array(0);
  products: any[];
  bannerSlides: any[] = [];
  expireTime = 5;
  timeout: boolean = true;
  params: any;
  loginData: { header: string; data: string };
  redirect: string = '';
  forgottenpwrd: boolean;
  closeModal = true;
  passModal = false;
  sessionUpdate = false;
  sessionUpdated$ = new BehaviorSubject(false);
  resetPass = new BehaviorSubject(0);
  bonusAvailable = new BehaviorSubject<number>(0);
  bannerMsg: string = "";
  userDataUpdated$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  updatePhoneNumber: BehaviorSubject<{change:boolean, phone:string, home: boolean}> = new BehaviorSubject({change: false, phone: '', home: true});
  moveBack() {
    let symbol = this.redirect.includes('?') ? '&' : '?';
    this.redirect.length ? window.location.assign(`${this.redirect}${symbol}session=${this.userData.session}`) : "";
  }
  confirmpaymentAccount(requestData: {
    sid: any;
    otp: any;
    id: any;
  }): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestHandler
        .authPost(
          this.configService.PROXIES.userService ,
            EndPoints.confirmOtpPayment,
          requestData
        )
        .then((data) => {
            resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  saveAccount(request: { sid: any; pvd: any; accnt: any }): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestHandler
        .authPost(
          this.configService.PROXIES.userService ,
            EndPoints.savePaymentAccnt,
          request
        )
        .then((data) => {
            resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  onLogIn = new BehaviorSubject(0);
  securityQuestions: Array<any>;
  validProviders = [];

  isProcessing = false;
  logingIn = false;
  credsValid = true;
  rememberMe = false;
  validationPatterns = {
    redirectDomain: /:\/\/([^\/]+)/,
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$/,
    passwd: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)\S{6,}$/
  }
  private _userData: User | null = null;
  private _username: any;
  private _password: any;
  private _error_msg: any;
  private _countries = [];
  public dialingCodes: Array<any> = [];
  private _showChangePasswordAlert: boolean;
  public get showChangePasswordAlert(): boolean {
    return this._showChangePasswordAlert;
  }
  public set showChangePasswordAlert(value: boolean) {
    this._showChangePasswordAlert = value;
  }
  public get error_msg(): any {
    return this._error_msg;
  }
  public set error_msg(value: any) {
    this._error_msg = value;
  }
  public lang: string = navigator.language.split('-')[0];
  constructor(
    public requestHandler: HttpService,
    private translate: TranslateService,
    public storageService: StorageService,
    private configService: ConfigService,
    private modalService: ModalService,
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  public get countries(): any {
    return this._countries;
  }
  public set countries(value: any) {
    this._countries = value;
  }
  public get username(): any {
    return this._username;
  }
  public set username(value: any) {
    this._username = value;
  }

  public get password(): any {
    return this._password;
  }
  public set password(value: any) {
    this._password = value;
  }

  public get userData(): User {
    return this._userData;
  }
  public set userData(value: User) {
    this._userData = value;
  }

  get userIsVerified(){
    return (this.userData && this.userData['isKycVerified']);
  }
  startIdleWatch() {
    this.idleInterval = setInterval(() => {
      this.userIdleTime = this.userIdleTime + 1;
    }, 60000);
    document.addEventListener("click", () => {
      this.userIdleTime = 0;
    });
    document.addEventListener("mousemove", () => {
      this.userIdleTime = 0;
    });
    document.addEventListener("keypress", () => {
      this.userIdleTime = 0;
    });
    document.addEventListener("change", () => {
      this.userIdleTime = 0;
    });
    document.addEventListener("scroll", () => {
      this.userIdleTime = 0;
    });
  }
  resendSMS(params: { phone: any }) {
    return this.requestHandler.Post(
      this.configService.PROXIES.userService ,
        EndPoints.resendVerificationCodeBySMS,
      params
    );
  }
  verifyPhone(params: { phone: string }) {
    return this.requestHandler.Hget(
      this.configService.PROXIES.userService,
      EndPoints.verifyPhone,
      params
    );
  }
  confirmCodeRequest(data): Promise<any> {
    return this.postRequest(
      this.configService.PROXIES.userService ,
        EndPoints.confirmCodeURL,
      data
    );
  }
  postRequest(api, url, data): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestHandler
        .Post(api, url, data)
        .then((response) => {
          if (response && response.erc === "1" && response.data) {
            resolve(response.data);
          } else {
            resolve(response);
          }
        })
        .catch((err) => console.log(err));
    });
  }
  // register(userData): Promise<any> {
  //   this.isProcessing = true;
  //   // if (userData.hasOwnProperty('birthday')) {
  //   //   userData.birthday = new Date(userData.birthday).getTime();
  //   // }
  //   return this.requestHandler.get_request(
  //     this.configService.PROXIES.userService + EndPoints.register,
  //     userData
  //   );
  // }
  validatePassword(word) {
    var pattern = /^(?=.{6,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])/;
    //  var pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)\S{6,}$/
    // var pattern2 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(\W|_)).{5,}$/
    var invalid;

    var checkval = pattern.test(word);
    // console.log(checkval)
    if (!checkval) {
      invalid = false;
    } else {
      invalid = true;
    }
    return invalid;
  }
  quickSignup(userData): Promise<any> {
    this.isProcessing = true;

    return this.requestHandler.Post(
      this.configService.PROXIES.userService ,
        EndPoints.quickSignup,
      userData
    );
  }
  register(userData): Promise<any> {
    this.isProcessing = true;
    // if (userData.hasOwnProperty('birthday')) {
    //   userData.birthday = new Date(userData.birthday).getTime();
    // }
    return this.requestHandler.Post(
      this.configService.PROXIES.userService ,
        EndPoints.register,
      userData
    );
  }
  private checkIsSelfExcluded(loginRespData: User): {start: any; end: any, isSelfExcluded: boolean} {
    if (loginRespData.hasOwnProperty("selfExclusion") && !isNullOrEmpty(loginRespData.selfExclusion)) {
      if(loginRespData.selfExclusion.type !== "SUSPEND")
        return {start: null, end: null, isSelfExcluded: false};

      // Parse Unix timestamps (numbers) to moment objects
      const startDate = moment(Number(loginRespData.selfExclusion.dtStart)).startOf('day');
      const endDate = moment(Number(loginRespData.selfExclusion.dtEnd)).endOf('day');
      const now = moment();

      if (now.isSameOrAfter(startDate) && now.isSameOrBefore(endDate)) {
        return {start: startDate, end: endDate, isSelfExcluded: true};
      }
      return {start: startDate, end: endDate, isSelfExcluded: false};
    }
    return {start: null, end: null, isSelfExcluded: false};
  }

  private async openSelfExcludedModal(dtEnd: any, session: string) {
    await this.modalService.openDialog(
      "account_suspended",
      this.translate.instant("rg_self_exclusion_active", {date: dtEnd.format('DD-MM-YYYY HH:mm:ss')}),
      true,
      false,
      null,
      "recover_account",
      "OK",
    ).then((action) => {
      // if(action.yesClicked) {
      //   this.router.navigate(['user-actions/recover-account'], {queryParams: {sessionId: session}});
      // }

    });
    this.cleanLocalSession();
  }

  async login(isMobile?): Promise<boolean> {
    this.logingIn = true;
    const params = {
      login: this.username,
      pwd: this.password,
      lang: this.lang,
      channel: 3,
    };
    this.error_msg = "";
    return new Promise((resolve, reject) => {
      this.requestHandler
        .Post_auth(
          this.configService.PROXIES.userService ,
            (!isMobile
              ? EndPoints.login_with_phonenumber
              : EndPoints.login),
          params
        )
        .then(async (response: Partial<CustomerAuthResp>) => {

          if (response.hasOwnProperty("erc") && response.erc === "0") {

            const checkSelfExcluded = this.checkIsSelfExcluded(response.data);
            if (checkSelfExcluded.isSelfExcluded) {
              await this.openSelfExcludedModal(checkSelfExcluded.end, response.data.session);
              resolve(false);
            }

            this.userData = response.data;
            this.configService.tempData = response.data;

            // this.replaceurl({session:null})
            this.storageService.setCookie(
              "session",
              this.userData.session,
              this.configService.expiry
            );

            let phone = this.userData.phone_number;
            if (phone.startsWith(this.configService.country_code)) {
              phone = phone.split(this.configService.country_code)[1]
              if (phone.length >= this.configService.phoneNumberLength) {
                this.onLogIn.next(1);
              }
            }
            this.saveToken();
            this.startIdleWatch();
            resolve(true);
          } else {
/*
            if (response.sessionToken) {
              await this.modalService
                .openDialog(
                  "security_alert",
                  "ml_more_than_one_session",
                  true,
                  false,
                  response.device
                )
                .then(async (data) => {
                  if (data.yesClicked) {
                    this.userData.customer_ID = response.customer_ID;
                    await this.renewSession(params);
                    if(this.userData.hasOwnProperty("session")){
                      let phone = this.userData.phone_number;
                      if (phone.startsWith(this.configService.country_code)) {
                        phone = phone.split(this.configService.country_code)[1]
                        if (phone.length >= this.configService.phoneNumberLength) {
                          this.onLogIn.next(1);
                        }
                      }
                    }
                    resolve(this.userData.hasOwnProperty("session"));
                  } else {
                    this.cleanLocalSession();
                  }
                });
            }
                */

            if (response.data && response.data.suspended) {
              await this.modalService
                .openDialog("security_alert", "suspend_account_msg", true)
                .then(async (data) => {
                  if (data.yesClicked) {
                    this.forgottenpwrd = true;
                    resolve(false);
                  } else reject(false);
                });
              return;
            }
            // tslint:disable-next-line:triple-equals

            if (response.sessionToken || response.msg == "ml_more_than_one_session") {
              // response.erc = '0109
              await this.modalService
                .openDialog(
                  "security_alert",
                  "ml_more_than_one_session",
                  true,
                  false,
                  response.data.device
                )
                .then(async (data) => {

                  if (data.yesClicked) {
                    this.userData = {...this.userData,
                      customer_ID: response.data.customer_ID,
                    };
                    await this.renewSession(params);

                    if(this.userData.hasOwnProperty("session")){
                      let phone = this.userData.phone_number;
                      if (phone.startsWith(this.configService.country_code)) {
                        phone = phone.split(this.configService.country_code)[1]
                        if (phone.length >= this.configService.phoneNumberLength) {
                          this.onLogIn.next(1);
                        }
                      }
                    }
                    resolve(this.userData.hasOwnProperty("session"));
                  } else {
                    this.cleanLocalSession();
                  }
                });
            } else if (response.msg == "ml_erc_client_blocked" || response.erc === '0106') {
              await this.modalService
                .openDialog("Login Error", response.msg, false)
                .then((data) => {
                  resolve(false);
                });
            }else if(response.erc == '239') {
              await this.resetPasswordPrompt();
            }
            else {
              this.error_msg = response.msg;
              this.userData = undefined;
              resolve(false);
            }
          }

          this.logingIn = false;
        })
        .catch((data) => {
          this.userData = undefined;
          this.logingIn = false;
          if (data.hasOwnProperty("ok") && !data.ok) {
            this.error_msg = data.error.message;
          } else {
            this.error_msg = data.msg;
            reject(false);
          }
        });
    });
  }
  replaceurl(params){
    this.router.navigate([''], {
        relativeTo: this.route,
        queryParams: params,
        replaceUrl: true,
      });
  }

  forgotPassword(){
    this.modalService.destroy();
    this.resetPass.next(1);
  }
  async resetPasswordPrompt(){
    await this.modalService.openDialog("security_alert", "reset_password", true)
    .then((data)=>{
      if (data.yesClicked){
        this.forgotPassword();
      }
      else{
        this.cleanLocalSession();
      }
    })
  }
  logout(): Promise<boolean> {
    const param = {
        sessionToken: this.userData ? this.userData.session : '',
    };
    return new Promise((resolve, reject) => {
      this.requestHandler
        .authPost(
          this.configService.PROXIES.userService ,
            EndPoints.logout,
          param
        )
        .then((response: any) => {
          this.timeout = false;
          this.setRefreshOfToken = false;
          this.cleanLocalSession();
          resolve(response);
        })
        .catch((logoutErr: HttpErrorResponse) => {
          if(logoutErr.error && logoutErr.error.hasOwnProperty('erc') && logoutErr.error['erc'] === '001') {
            this.setRefreshOfToken = false;
            this.cleanLocalSession();
          }
          reject(logoutErr);
        });
    });
  }

  handleLogout(){
    this.router.navigate(['home']).then(() => {
          this.logout().then(() => {
            this.modalService.openSessionExpires().then((check) => {
              if(check.yesClicked){
                this.router.navigate(['/user/login']);
              }
            });
          });
      });
  }

  updateUser(userData?): Promise<any> {
    // this.isProcessing = true;
    console.log(userData);
    const params = this.buildObjct(userData ? userData : this.userData);
    console.log(params);
    let dt = new Date(params.str_Birthdate);

    params.str_Birthdate =
      dt.getDate() + "/" + (dt.getMonth() + 1) + "/" + dt.getFullYear();

    return this.requestHandler.authPost(
      this.configService.PROXIES.userService ,
        EndPoints.updateProfile,
      params
    );
  }
  buildObjct(userdata) {
    const params = {
      str_Login: userdata.login.trim(),
      str_Account_Code: userdata.account_code.trim(),
      str_Address: userdata.address,
      str_Birthdate: userdata.birthday,
      str_CNI: userdata.cni.trim(),
      str_lg_Agent_Id: userdata.customer_ID,
      str_Email: userdata.email.trim(),
      str_FName: userdata.first_name,
      str_Lang: userdata.lang,
      str_LName: userdata.last_name,
      str_Nationalite: userdata.nationality,
      str_Phone_Number: this.configService.country_code + userdata.phone_number.trim(),
      str_Sexe: userdata.sex,
      str_Session: userdata.session,
      str_Town: userdata.town,
      str_Statut: userdata.status,
      str_channel: 3,
      sid: userdata.sid? userdata.sid : userdata.session
    };
    return params;
  }
  isUserProfileComplete() {
    const userDetials = this.userData;
    if (
      (userDetials.hasOwnProperty("email") &&
        userDetials.email.trim() === "") ||
      userDetials.login === userDetials.phone_number ||
      (userDetials.hasOwnProperty("first_name") &&
        userDetials.first_name.trim() === "") ||
      (userDetials.hasOwnProperty("last_name") &&
        userDetials.last_name.trim() === "") ||
      (userDetials.hasOwnProperty("sex") && userDetials.sex.trim() === "") ||
      (userDetials.hasOwnProperty("lang") &&
        userDetials.lang.toString() === "") ||
      (userDetials.hasOwnProperty("birthday") &&
        new Date(userDetials.birthday).getFullYear() + 18 >
          new Date().getFullYear()) ||
      (userDetials.hasOwnProperty("cni") && userDetials.cni.trim() === "")
    ) {
      return false;
    } else {
      return true;
    }
  }
  loadActivePartners() {

    return this.requestHandler
      .get_request(
        this.configService.PROXIES.userService ,
          EndPoints.partners,
        {}
      )
      .then((res) => {
        this.partners = res.data.map(partner => {
            return {
              ...partner,
              desc: this.removeSpace(partner.name.toLowerCase(), '_').concat("_partner_desc")
            }
          } );
      });
  }
  removeSpace(str: string, delimiter = ''){
    return str.replace(/\s/g, delimiter);
  }
  changePassword(passwords): Promise<any> {
    this.isProcessing = true;
    return this.requestHandler.authPost(
      this.configService.PROXIES.userService ,
        EndPoints.changePassword,
      passwords
    );
  }
  changePin(pins): Promise<any> {
    this.isProcessing = true;
    return this.requestHandler.authPost(
      this.configService.PROXIES.userService ,
        EndPoints.changePin,
      pins
    );
  }
  getTransactions(params: any): Promise<any> {
    return this.requestHandler.get_auth(
      this.configService.PROXIES.userService,
        EndPoints.transactions,
      params
    );
  }

  getCustomerTransactions(params: customerTransPayload): Promise<any> {
    return this.requestHandler.get_auth(
      this.configService.PROXIES.userService,
        EndPoints.customerTransactions,
      params
    );
  }

  getDetailedBetTransactions(params: any): Promise<any> {
    return this.requestHandler.get_auth(
      this.configService.PROXIES.userService,
        EndPoints.transactionsHistory,
      params
    );
  }
  getTransactionDetails(params: any, provider) {

    // url = provider.toLowerCase() == "sportcash" ? url + params.ref : url;
    return this.requestHandler.get_auth(
      this.configService.PROXIES[provider.toLowerCase()] ,
      this.configService.EndPoints[provider.toLowerCase() + "_transactions"],
      params
    );
  }

  loadSlides() {
    // const perpage = 20;
    // this.searchdata = searchdata;
    // let param = {page:0, perpage: 20, currentPage: 0 };
    return this.requestHandler.get_request(
      this.configService.PROXIES.sportcash , "sport/sliders",
      { channel_id: "LONACI", status: "true" },
      true
    );
  }
  filterPartners(params: any): Promise<any> {
    // console.log('params')
    return this.requestHandler.get_request(
      this.configService.PROXIES.userService
      ,
       EndPoints.allPartners,
      params
    );
  }
  filterProducts(params: any) {
    return this.requestHandler.get_request(
      this.configService.PROXIES.userService
      , EndPoints.allProducts,
      params
    );
  }
  getAccountTransactions(params: any): Promise<any> {
    return this.requestHandler.get_auth(
      this.configService.PROXIES.userService ,
        EndPoints.payment_transactions,
      params
    );
    return;
  }
  verifyEmail(params: { email: string }) {
    return this.requestHandler.Hget(
      this.configService.PROXIES.userService,
      EndPoints.verifyEmail,
      params
    );
  }
  verifyUserName(params: { username: string }) {
    return this.requestHandler.Hget(
      this.configService.PROXIES.userService,
      EndPoints.verifyUserName,
      params
    );
  }
  checkProvider(phone_number) {
    var validPhone = false;
    if (!this.validProviders.length) return true;
    for (let prov of this.validProviders) {
      // console.log(prov + "   " + phone_number.toString().substring(0,2))
      if (phone_number.toString().startsWith(prov)) {
        validPhone = true;
        return validPhone;
      }
    }

    // if(!validPhone){
    //   this.modalService.isError = true;
    //   this.modalService.title = 'sorry';
    //   this.modalService.msg = 'mobile_prov_unvailable';
    //   this.modalService.showModal();
    //   // this.registrationForm.controls['password'].setErrors({ 'incorrect': true });
    //   return validPhone;
    // }
    return validPhone;
  }

  verifyAccount(params: any): Promise<any> {
    return this.requestHandler.Post_auth(
      this.configService.PROXIES.userService ,
        EndPoints.recover1,
      params
    );
  }
  resetPassword(params: any): Promise<any> {
    return this.requestHandler.Post_auth(
      this.configService.PROXIES.userService ,
        EndPoints.recover2,
      params
    );
  }

  updateUserAttribute(attrib: string, value: any) {
    this.userData[attrib] = value;
    // console.log(this.userData);
    if (this.storageService.getObject("user", false)) {
      this.storageService.save("user", this.userData);
    }
  }
  getSecurityQuestions() {
    let params = {};
    params["channel"] = 7;
    params["versioncode"] = 3;
    // params["date_jr"] = " ";
    this.requestHandler
      .Hget(this.configService.PROXIES.userService , "user/security-questions", params)
      .then((response: any) => {
        this.securityQuestions = response.data;
        this.securityQuestions.unshift({});
      });
  }
  triggerCashout(refCode: any): Promise<any> {
    return this.requestHandler.Hget(
      this.configService.PROXIES.turf_gateway,
      EndPoints.cashout + "/" + refCode + "",
      {}
    );
  }
  completeCashout(id: any, cashoutvalue: number) {
    const params = {
      bid: id,
      uid: this.userData.customer_ID,
      amt: cashoutvalue,
    };
    return this.requestHandler.PostRequest(
      this.configService.PROXIES.turf_gateway,
      EndPoints.completeCashout +
        this.requestHandler.parseParams(params),
      params
    );
  }
  getCountryList(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      fetch("../assets/countries.json")
        .then((res) => res.json())
        .then((res) => {
          this.countries = res;
          // this.countries.unshift({});
          resolve(true);
        })
        .catch((err) => {
          reject(false);
          // console.log("error is ", err);
        });
    });
  }
  resendActivation(value: any) {
    return this.requestHandler.Post(
      this.configService.PROXIES.userService ,
        EndPoints.resendMail,
      { email: value, lang: this.translate.currentLang }
    );
  }

  refreshSession() {
    this.requestHandler
      .Post(this.configService.PROXIES.userService, "user/session/renew", {
        agent: this.userData.customer_ID,
      })
      .then((data) => {
        if (!data.hasOwnProperty("erc") || data.erc == "0") {
          // console.log("invalid User");
        }else if(data.erc == "239"){
          this.resetPasswordPrompt()
        }
        else {
          this.userData.session = data.data;
          this.storageService.save("user", this.userData.session);
        }
      });
  }
  async renewSession(params:any={}) {
    params.agent=this.userData.customer_ID,
    params.channel= 3;
    return Promise.resolve(
      this.requestHandler
        .Post_auth(
          this.configService.PROXIES.userService, "user/session/renew-api",
          params
        )
        .then(async (data: any) => {
          if (
            (data.hasOwnProperty("erc") && data.erc == "0") ||
            data.erc == 0
          ) {
            const checkSelfExcluded = this.checkIsSelfExcluded(data.data);
            if (checkSelfExcluded.isSelfExcluded) {
              await this.openSelfExcludedModal(checkSelfExcluded.end, data.data.session);
              return false;
            } else {

              this.userData = data.data;
              this.configService.tempData = data.data;
              this.storageService.setCookie(
                "session",
                this.userData.session,
                this.configService.expiry
              );
              this.saveToken();
              return true;
            }
          } else if(data.erc == '239'){
            this.resetPasswordPrompt();
            return false;
          }
          else {
            let msg = (data.erc == '014' || data.erc == '001') ? 'ml_session_expired_reconnect' : 'connection_error';
            this.cleanLocalSession();
            this.router.navigate(['home']);
            this.modalService.openDialog('ml_error', msg, true).then((check) => {
              if(check.yesClicked){
                this.router.navigate(['/user/login']);
              }
            });
          }
          return false;
        })
    );
  }
  authSession(id) {
    let success = true;
    if (!id) return;
    return Promise.resolve(
      this.requestHandler
        .get_auth(this.configService.PROXIES.userService , EndPoints.userLoginSession + id, {refresh_token: this.configService.USER_AUTHORISATION.refresh_token})
        .then(async (data: any) => {
          if (
            (data.hasOwnProperty("erc") && data.erc == "0") ||
            data.erc == 0
          ) {
            const checkSelfExcluded = this.checkIsSelfExcluded(data.data);
            if (checkSelfExcluded.isSelfExcluded) {
              await this.openSelfExcludedModal(checkSelfExcluded.end, data.data.session);
              success = false;
              return false;
            }
            this.userData = data.data;
            this.configService.tempData = data.data;
            if ("lang" in this.userData &&
              this.userData.lang.length > 1 && !this.configService.lang
            ) {
                this.configService.lang = (this.userData.lang + '')
                .toString()
                .replace(/lang_/gi, '');
            }
          // if(this.userDataUpdated$.getValue() == false){
          //   this.onLogIn.next(1);
          // }
            this.saveToken();
            this.storageService.setCookie(
              "session",
              this.userData.session,
              this.configService.expiry
            );
            this.onLogIn.next(1);
            this.storageService.save("userData", this.userData);
            this.startIdleWatch();
          } else if(data.hasOwnProperty("erc") && data.erc == '239'){
            this.resetPasswordPrompt();
          } else {
            this.modalService.closeAllModals();
            let msg = (data.erc == '014' || data.erc == '001') ? 'ml_session_expired_reconnect' : 'connection_error';
            this.cleanLocalSession();
            this.router.navigate(['home']);
            this.modalService.openDialog('ml_error', msg, true).then((check) => {
              if(check.yesClicked){
                this.router.navigate(['/user/login']);
              }
            });
            success = false;
          }

          return success;
        })
        .catch((err) => {
          console.log(err);
          this.modalService.closeAllModals();
          let msg = (err.error.erc == '014' || err.error.erc == '001') ? 'ml_session_expired_reconnect' : 'connection_error';
            this.cleanLocalSession();
            this.router.navigate(['home']);
            this.modalService.openDialog('ml_error', msg, true).then((check) => {
              if(check.yesClicked){
                this.router.navigate(['/user/login']);
              }
            });
          return false;
        }).finally(()=>{
          // this.replaceurl({session:null});
        })
    );
  }
  cleanLocalSession() {
    this.resetPass.next(0);
    this.onLogIn.next(0);

    this.storageService.deleteCookie("session");
    this.storageService.deleteItem("auth")
    this.storageService.deleteItem("userData");
    this.storageService.deleteItem("user");
    this.userData = undefined;
    this.configService.USER_AUTHORISATION = {access_token: "", refresh_token:"", expiry:new Date()};
  }

  setLoggedInUserUrlParams(){
    if(this.userData && this.configService.USER_AUTHORISATION)
    return `session=${this.userData.session}&token=${this.configService.USER_AUTHORISATION.access_token}&refresh-token=${this.configService.USER_AUTHORISATION.refresh_token}&expire_at=${this.configService.USER_AUTHORISATION.expiry}&token_duration=${this.configService.USER_AUTHORISATION.token_duration}`
  }

  public downloadGuide(url, name?) {
    let pdfReqBody = {
      url: url,
      title: name,
    };

    this.requestHandler
      .get_request(url, pdfReqBody, { responseType: "blob" })
      .then((res) => {
        let blob = new Blob([res], { type: "application/pdf" });
        let pdfUrl = window.URL.createObjectURL(blob);

        var PDF_link = document.createElement("a");
        PDF_link.href = pdfUrl;
        //   TO OPEN PDF ON BROWSER IN NEW TAB
        // window.open(pdfUrl, '_blank');
        //   TO DOWNLOAD PDF TO YOUR COMPUTER
        PDF_link.download = `${name.replaceAll(" ", "-")}`;
        PDF_link.click();
      });
  }
  updateUserBalance() {
    let params = {
      lg_Client_ID: this.userData.customer_ID,
    };
    this.requestHandler
      .authPost(
        this.configService.PROXIES.userService ,
          EndPoints.user_balance,
        params
      )
      .then((res) => {
        console.log(res);
      });
  }

  fetchUserTransactionExtras() {
    const lg_Client_ID = this.userData.customer_ID;
    return this.requestHandler.get_request(
    this.configService.PROXIES.userService.split('/v2/')[0] + '/transac-service/',
      lg_Client_ID + EndPoints.transactionSummary, {}
    );
  }

  setTokenData(object){
    if(object['token'] && object.token_duration && object['refresh-token'] && object['expire_at']){
      this.configService.USER_AUTHORISATION = {access_token: decodeURIComponent(object['token'])  ,refresh_token: decodeURIComponent(object['refresh-token']) , expiry:object['expire_at'], token_duration:object.token_duration}
    }
  }

  async refreshUsersContext(userID, token?) {

    if(this.configService.USER_AUTHORISATION.access_token == "")
    return
    return this.requestHandler
      .get_auth(
        this.configService.PROXIES.userService,
        'user/auth/' + (userID ? userID : this.userData.session),
        {refresh_token: this.configService.USER_AUTHORISATION.refresh_token}
      )
      .then((data) => {
        if (!data.hasOwnProperty('erc') || data.erc != '0' || data.erc != '239') {
          throw new Error('not logged in');
        } else if(data.hasOwnProperty("erc") && data.erc == '239'){
          this.resetPasswordPrompt();
        }
        else {
          if (data.hasOwnProperty('data') && data.data.session != null) {
            this.userData = data.data;
            if (
              this.userData.hasOwnProperty('lang') &&
              this.userData.lang.length > 1 && !this.configService.lang
            ) {
                this.configService.lang = (this.userData.lang + '')
                .toString()
                .replace(/lang_/gi, '');
            }
            this.onLogIn.next(1);
            // this.saveNewSession(this.userData.session);
            this.saveToken();
          }
        }
      });
    // }
  }


  saveNewSession(sessionID: any) {
    if (this.urlSessionId && this.urlSessionId.length) {
      this.router.navigateByUrl(
        this.router.url.replace(this.urlSessionId, sessionID)
      );
    }
    this.storageService.setCookie('session', sessionID, this.configService.expiry);
    if(this.configService.USER_AUTHORISATION){
      this.storageService.save('auth',  this.configService.USER_AUTHORISATION)
    }

  }
  saveToken(){
    if(this.userData){
      const { access_token, refresh_token, token_duration, ...rest} = this.userData;
      if(access_token){
        this.configService.USER_AUTHORISATION.access_token = 'Bearer ' + access_token;
      }

      if(refresh_token){
        this.configService.USER_AUTHORISATION.refresh_token = refresh_token;
      }

      if(token_duration){
        this.configService.USER_AUTHORISATION.token_duration = token_duration;
        this.configService.USER_AUTHORISATION.expiry = new Date(Date.now() + token_duration);
      }

    } else {
      this.configService.USER_AUTHORISATION = null;
      // Logout user when no access_token is present
      this.handleLogout();
      return; // Exit early to prevent scheduling token refresh
    }

    this.saveNewSession(this.userData.session);

    if(!this.setRefreshOfToken){
      setTimeout(() => {
        // Check if USER_AUTHORISATION still exists and has access_token
        if(!this.configService.USER_AUTHORISATION || !this.configService.USER_AUTHORISATION.access_token || !this.userData){
          this.handleLogout();
          return;
        }

        this.authService.getTokenRequest()
          .catch(err => {
            // If token refresh fails, logout the user
            console.error('Token refresh failed:', err);
            this.handleLogout();
          });
        this.setRefreshOfToken = true;
      }, this.userData.token_duration);
    }
  }

  confirmAccount(params) {
    return this.requestHandler.Post(this.configService.PROXIES.userService ,
      EndPoints.confirm_account, params)
  }

  initializeKYC(clientId: string, sessionId: string | null = null){
    let payload: any = { clientId }
    if(sessionId){
      payload = {...payload, sessionId};
    }
    return this.requestHandler.Post(this.configService.PROXIES.userService, EndPoints.verify_user, payload);
    // return this.requestHandler.Post("http://10.12.1.187:45757/", EndPoints.verify_user, payload);
  }

  setDelayToResendCode() {
    const exp = new Date(
      new Date().getTime() + (30 * 1000)
    );
    this.storageService.setCookie(
      STORAGE_KEYS.WAIT_TO_RESEND_CODE,
      {
        expiresAt: {
          time: exp.getTime(),
          date: exp,
        },
      },
      exp
    );
  }


}
